declare namespace $ {

	type $shm_projects_tasks_panel__title_shm_projects_tasks_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_tasks_panel['title'] >
	>
	type $shm_projects_tasks_panel__add_title_shm_projects_tasks_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_tasks_panel['add_title'] >
	>
	type $shm_projects_tasks_panel__filter_shm_projects_tasks_3 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['filter'] >
		,
		ReturnType< $shm_projects_tasks_panel['filter'] >
	>
	type $shm_projects_tasks_panel__sort_by_shm_projects_tasks_4 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['sort_by'] >
		,
		ReturnType< $shm_projects_tasks_panel['sort_by'] >
	>
	type $shm_projects_tasks_panel__sort_order_shm_projects_tasks_5 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['sort_order'] >
		,
		ReturnType< $shm_projects_tasks_panel['sort_order'] >
	>
	type $shm_projects_tasks_panel__add_shm_projects_tasks_6 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_add'] >
		,
		ReturnType< $shm_projects_tasks_panel['add'] >
	>
	type $shm_projects_tasks_panel__task_rows_shm_projects_tasks_7 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_rows'] >
		,
		ReturnType< $shm_projects_tasks_panel['task_rows'] >
	>
	type $shm_projects_tasks_panel__task_arg_shm_projects_tasks_8 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_arg'] >
		,
		ReturnType< $shm_projects_tasks_panel['task_arg'] >
	>
	type $shm_projects_tasks_panel__task_title_shm_projects_tasks_9 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_title'] >
		,
		ReturnType< $shm_projects_tasks_panel['task_title'] >
	>
	type $shm_projects_tasks_panel__task_current_shm_projects_tasks_10 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_current'] >
		,
		ReturnType< $shm_projects_tasks_panel['task_current'] >
	>
	type $shm_projects_tasks_panel__task_is_new_shm_projects_tasks_11 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_projects_tasks_panel['task_is_new'] >
	>
	type $mol_view__sub_shm_projects_tasks_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_projects_task__project_id_shm_projects_tasks_13 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['project_id'] >
		,
		ReturnType< $shm_projects_task['project_id'] >
	>
	type $shm_projects_task__task_id_shm_projects_tasks_14 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks['task_id'] >
		,
		ReturnType< $shm_projects_task['task_id'] >
	>
	export class $shm_projects_tasks extends $mol_book2 {
		task_pages( ): readonly(any)[]
		task_add( next?: any ): any
		task_rows( ): readonly(any)[]
		task_arg( id: any): Record<string, any>
		task_title( id: any): string
		task_current( id: any): boolean
		task_id( id: any): string
		project_id( ): string
		filter( next?: string ): string
		sort_by( next?: string ): string
		sort_order( next?: string ): string
		pages( ): ReturnType< $shm_projects_tasks['task_pages'] >
		List( ): $shm_projects_tasks_panel
		Empty( ): $mol_view
		Task( id: any): $shm_projects_task
	}
	
}

//# sourceMappingURL=tasks.view.tree.d.ts.map